'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgBulletlist, SvgCalendarBlank } from '@common/icon';
import { cn } from '@core/utils';
import { useSearchParams } from 'next/navigation';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useSubscribedState } from '@/hooks/useSubscribedState';
import type { ViewMode } from '../_types/types';
export const ViewModeToggle = () => {
  const $ = _c(25);
  const {
    push
  } = useCustomRouter();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get("viewMode") as ViewMode ?? "timeline";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentViewMode = t0;
  const [localViewMode, setLocalViewMode] = useSubscribedState(currentViewMode);
  let t1;
  if ($[2] !== localViewMode || $[3] !== push || $[4] !== searchParams || $[5] !== setLocalViewMode) {
    t1 = () => {
      const newViewMode = localViewMode === "list" ? "timeline" : "list";
      setLocalViewMode(newViewMode);
      const params = new URLSearchParams(searchParams?.toString());
      params.set("viewMode", newViewMode);
      push(ROUTES.RECOMMEND_POLICY_LIST.withSearchParams({
        searchParams: Object.fromEntries(params)
      }));
    };
    $[2] = localViewMode;
    $[3] = push;
    $[4] = searchParams;
    $[5] = setLocalViewMode;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleToggle = t1;
  const t2 = `${localViewMode === "list" ? "\uD0C0\uC784\uB77C\uC778" : "\uB9AC\uC2A4\uD2B8"} 뷰로 전환`;
  const t3 = localViewMode === "timeline" ? "translate-x-0" : "translate-x-full";
  let t4;
  if ($[7] !== t3) {
    t4 = cn("absolute size-24 rounded-medium bg-Gray-white shadow-sm transition-transform duration-200 ease-out", t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className={t4} />;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = localViewMode === "timeline" ? "text-Gray-900" : "text-Gray-550";
  let t7;
  if ($[11] !== t6) {
    t7 = cn("size-12 transition-colors", t6);
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div className="relative z-[1] flex size-24 items-center justify-center px-4"><SvgCalendarBlank className={t7} /></div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = localViewMode === "list" ? "text-Gray-900" : "text-Gray-550";
  let t10;
  if ($[15] !== t9) {
    t10 = cn("size-12 transition-colors", t9);
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <div className="relative z-[1] flex size-24 items-center justify-center px-4"><SvgBulletlist className={t10} /></div>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== handleToggle || $[20] !== t11 || $[21] !== t2 || $[22] !== t5 || $[23] !== t8) {
    t12 = <button type="button" onClick={handleToggle} className="relative flex items-center rounded-pill bg-Gray-300 p-5" aria-label={t2}>{t5}{t8}{t11}</button>;
    $[19] = handleToggle;
    $[20] = t11;
    $[21] = t2;
    $[22] = t5;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};